export default [{
  id: 1,
  value: '移动应用',
  children: [{
    id: 10000,
    value: '社交网络',
    key: {
      android: [10000],
      other: [10000]
    }
  }, {
    id: 10002,
    value: '常用工具',
    key: {
      android: [10002],
      other: [10002]
    }
  }, {
    id: 10003,
    value: '影音图像',
    key: {
      android: [10003],
      other: [10003]
    }
  }, {
    id: 10004,
    value: '阅读学习',
    key: {
      android: [10004],
      other: [10015]
    }
  }, {
    id: 10005,
    value: '网上购物',
    key: {
      android: [10005],
      other: [10005]
    }
  }, {
    id: 10006,
    value: '金融理财',
    key: {
      android: [10006],
      other: [10008]
    }
  }, {
    id: 10007,
    value: '生活服务',
    key: {
      android: [10007],
      other: [10004]
    }
  }, {
    id: 10008,
    value: '旅游出行',
    key: {
      android: [10008],
      other: [10006]
    }
  }, {
    id: 10009,
    value: '通信聊天',
    key: {
      android: [10009],
      other: [10009]
    }
  }, {
    id: 10011,
    value: '办公软件',
    key: {
      android: [10011],
      other: [10007]
    }
  }, {
    id: 10013,
    value: '性能优化',
    key: {
      android: [10013],
      other: [10013]
    }
  }, {
    id: 10014,
    value: '新闻资讯',
    key: {
      android: [10014],
      other: [10011]
    }
  }, {
    id: 10015,
    value: '美化手机',
    key: {
      android: [10015],
      other: [10014]
    }
  }, {
    id: 10028,
    value: '育儿母婴',
    key: {
      android: [10028],
      other: []
    }
  }]
}, {
  id: 2,
  value: '移动游戏',
  children: [{
    id: 10010,
    value: '休闲时间',
    key: {
      android: [10010],
      other: [10010]
    }
  }, {
    id: 10001,
    value: '动作射击',
    key: {
      android: [10001],
      other: [10020]
    }
  }, {
    id: 10020,
    value: '跑酷竞速',
    key: {
      android: [10020],
      other: [10030, 10022]
    }
  }, {
    id: 10018,
    value: '经营策略',
    key: {
      android: [10018],
      other: [10021]
    }
  }, {
    id: 10016,
    value: '扑克棋牌',
    key: {
      android: [10016],
      other: [10016]
    }
  }, {
    id: 10025,
    value: '角色扮演',
    key: {
      android: [10025],
      other: [10029]
    }
  }, {
    id: 10029,
    value: '网络游戏',
    key: {
      android: [10029],
      other: [10001]
    }
  }, {
    id: 10021,
    value: '体育格斗',
    key: {
      android: [10021],
      other: [10025]
    }
  }, {
    id: 10030,
    value: '儿童益智',
    key: {
      android: [10030, 10022],
      other: [10018]
    }
  }, {
    id: 10012,
    value: '宝石消除',
    key: {
      android: [10012],
      other: []
    }
  }, {
    id: 10019,
    value: '塔防守卫',
    key: {
      android: [10019],
      other: []
    }
  }]
}]
